// extracted by mini-css-extract-plugin
export default {"light-cta":"y0Gu30","lightCta":"y0Gu30","arrow-btn-rotate":"UVhikK","arrowBtnRotate":"UVhikK"};